class BackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button.addEventListener('click', () => this.scrollToTop());
    window.addEventListener('scroll', () => this.handleScroll());
  }

  scrollToTop() {
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  handleScroll() {
    ['opacity-0', 'invisible', 'pointer-events-none'].forEach((className) => {
      window.scrollY > 200 ? this.classList.remove(className) : this.classList.add(className);
    });
  }
}

customElements.define('back-to-top', BackToTop);
